// extracted by mini-css-extract-plugin
export default {"input":"y--z","button":"z--z","selected":"A--z","unavailable":"B--z","oos":"C--z","image":"D--z","paperCutDisabledOverlay":"E--z"};